import React from 'react'
import styled from 'styled-components'
import { Segment } from 'semantic-ui-react'
import { FakeInput } from 'shared/StyledComponents'

import { withConstantPermissions, colors } from 'shared'
import LKButton from 'shared/LKButton'
import { FormField } from 'shared/reactForm'
import FormFieldRaw from 'shared/newFormElements'
import { LKHeader, LKIcon } from 'loankeeper-common/components'
import { translate as mainTranslate } from 'loankeeper-common/helpers'
import ClientAdd, { ClientAddButtonTrigger } from '../../ClientAdd'
import { useSelectClient } from './select-client-context'

const translate = (key) => mainTranslate(`frm_account_add-${key}`)

export const SelectedClient = () => {
  const { clientName } = useSelectClient()

  return (
    <FakeInput>
      <Segment style={{ display: 'flex', alignItems: 'center' }}>
        <LKHeader
          size="small"
          style={{
            color: colors.red,
            fontWeight: 'bold',
            lineHeight: '100%',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
          }}
        >
          {clientName}
        </LKHeader>
      </Segment>
    </FakeInput>
  )
}

const SelectClientInputBase = ({ component: Component, withListeners, ...rest }) => {
  const { onSearch, isFetching } = useSelectClient()
  const props = Object.assign({}, rest)
  props.isPersonalNo = true

  const listeners = withListeners
    ? {
        onBlur: () => onSearch('ABORT_IF_UNCHANGED'),
      }
    : {}

  return (
    <Component
      name="PersonalNo"
      {...props}
      {...listeners}
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          onSearch()
        }
      }}
      type="text"
      loading={isFetching}
      maxLength={20}
    />
  )
}

export const SelectClientInput = (props) => <SelectClientInputBase {...props} component={FormField} />

export const SelectClientInputRaw = (props) => <SelectClientInputBase {...props} component={FormFieldRaw} />

export const SelectClientInputCounter = ({ style = {} }) => {
  const { pin } = useSelectClient()

  return (
    <span style={{ ...style, color: colors.red, fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>
      {pin.length}
    </span>
  )
}

export const SelectClientInputIndicator = ({
  clientNotFound,
  clientWatched,
  clientBlacklisted,
  renderText,
  withCounter,
}) => {
  const text =
    typeof renderText === 'function' ? renderText({ clientNotFound, clientWatched, clientBlacklisted }) : null

  return (
    <>
      {withCounter && <SelectClientInputCounter style={{ marginRight: 10 }} />}
      {text && <span style={{ color: colors.red, fontWeight: 'bold' }}>{text}</span>}
    </>
  )
}

export const HintIcon = () => {
  const { mainClient } = useSelectClient()

  if (!mainClient) {
    return null
  }

  if (mainClient.hasOwnProperty('Black')) {
    if (mainClient.Black === 1) {
      if (mainClient.Watched === 1) {
        return (
          <>
            <LKIcon alias={'alert'} size={30} />
            <LKIcon alias={'skull'} size={30} />
          </>
        )
      }
      return <LKIcon alias={'skull'} size={30} />
    }
    if (mainClient.Watched === 1) {
      return <LKIcon alias={'alert'} size={30} />
    }
    if (mainClient.Black !== 1) {
      return <LKIcon alias={'ok'} size={30} />
    }
  }

  return null
}

SelectClientInputIndicator.defaultProps = {
  withCounter: true,
}

const StyledSelectClientButton = styled(({ onlyIcon, ...attrs }) => <LKButton {...attrs} />)`
  &.ui.button.lk-button {
    ${(props) =>
      props.onlyIcon &&
      `
      padding: 5px !important;

      div {
        margin: 0 !important;
      }
    `}
  }
`

export const SelectClientButton = ({ text, disabled, onlyIcon, isAllowed }) => {
  const context = useSelectClient()

  if (!context.canViewClient || !isAllowed) {
    return null
  }

  return (
    <StyledSelectClientButton
      alias="hand"
      name="cmd_select_client"
      onClick={context.openSearch}
      disabled={disabled}
      onlyIcon={onlyIcon}
    >
      {!onlyIcon && (text || translate('cmd_select_client'))}
    </StyledSelectClientButton>
  )
}

SelectClientButton.defaultProps = {
  text: undefined,
  onlyIcon: false,
  isAllowed: true,
}

export const AddClientButton = withConstantPermissions()(
  ({ className, permissions, permission, name, isAllowed, params, disabled, onClose, children }) => {
    const { onAddOrUpdateClient, clientGroup, clientType } = useSelectClient()

    if (permission && !permissions[permission]) {
      return null
    }

    if (!isAllowed(clientType)) {
      return null
    }

    return (
      <>
        <ClientAddButtonTrigger
          className={className}
          name={name}
          params={{
            groupid: clientGroup,
            ...params,
          }}
          disabled={disabled}
        >
          {children}
        </ClientAddButtonTrigger>
        <ClientAdd name={name} onClientAddEdit={onAddOrUpdateClient} onClose={onClose} detailsInModal />
      </>
    )
  },
)

AddClientButton.defaultProps = {
  name: 'SelectClientElement-AddClientButton',
  isAllowed: () => true,
  params: {},
}

export const ClearClientButton = ({ onClick, disabled }) => (
  <LKButton alias="clear" onClick={onClick} disabled={disabled} />
)
